<template lang="pug">
    div.creators-list-control
        scrollable-layout.creators-list-control_scrollable(:maxHeight="true")
            div.creators-list-control__item(v-for="(creator, idx) in creators" :class="getItemClass(idx)" @click="click(creator)")
                creator-control(:creator="creator")
                slot(name="item-decorator" :creator="creator")
</template>

<script>
export default {
    name: 'creators-list-control',

    props: {
        creators: {
            type: Array,
            required: true,
        },
        selectedIndex: {
            type: Number,
        },
        clickCallback: {
            type: Function,
        },
    },

    methods: {
        click(creator) {
            if (this.clickCallback) {
                this.clickCallback(creator)
            }
            else {
                this.goToProfile(creator)
            }
        },

        goToProfile(creator) {
            this.$emit('goToProfile', creator)
            this.$router.push(`/user/${creator.username}`)
        },

        getItemClass(idx) {
            return {
                'creators-list-control__item--selected': this.selectedIndex === idx,
            }
        },
    },
}
</script>